import styled from "styled-components";

export const Container = styled.div`
	min-height: var(--main-hight);

	un {
		color: var(--light-green);
	}

	.top-content {
		display: flex;
		align-items: center;
		position: relative;

		img {
			z-index: 0;
			width: 100vw;
			filter: blur(0.5px);
		}

		p {
			text-align: justify;
			font-weight: 700;
			/* background-color: rgba(131, 133, 131, 0.37); */
			padding: 10px;
			border-radius: 10px;
			backdrop-filter: blur(5px);
			strong {
				color: var(--light-green);
				font-size: 34px;
				font-weight: 800;
				text-shadow: 1px 0px 13px #545954;

				/* border-bottom: 5px solid var(--light-green); */
			}
			z-index: 100;
			position: absolute;
			left: calc(100vw - 50%);
			/* top: 10%; */
			width: 700px;
			font-size: 34px;
			font-weight: 800;
			color: var(--dark-blue);
			text-shadow: 1px 0px 13px rgb(247, 247, 247);
		}
	}

	.slogan-wrapper {
		display: flex;
		justify-content: center;

		img {
			width: calc(100vw - 60%);
		}
		margin: 30px 0;
	}

	#bottom {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100vw;
		text-align: center;
		p {
			width: 800px;
			font-size: 20px;
			height: 60px;
		}
		a {
			border-bottom: 3px solid var(--main-green);
			cursor: pointer;
			color: var(--main-green);
			transition: 0.3s;
		}
		a:hover {
			color: var(--light-green);
			border-bottom: 3px solid var(--light-green);
		}

		margin: 30px 0;
	}

	.mid-content {
		.content {
			max-width: 100vw;
			display: flex;
			flex-direction: row;
			justify-content: center;
			gap: 40px;
			padding: 30px;
		}
		background-color: var(--darkest-blue);

		p {
			width: 500px;
			color: white;
			text-align: justify;
		}

		img {
			border-radius: 15px;
			width: 400px;
		}
	}

	.btn {
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;

		a {
			width: 600px;
			background: linear-gradient(45deg, var(--dark-blue), #4a00e0);
			padding: 20px;
			margin: 50px;
			border-radius: 15px;
			font-size: 24px;
			font-weight: 600;
			color: white;
			transition: 600ms ease;

			-webkit-box-shadow: -1px 6px 10px -8px #000000;
			-moz-box-shadow: -1px 6px 10px -8px #000000;
			box-shadow: -1px 6px 10px -8px #000000;
		}
		a:hover {
			scale: 1.02;
			opacity: 0.9;
		}
	}

	.page-wrapper {
		padding: 40px 20px;
	}

	/* --- Cabeçalho --- */
	.section-header {
		text-align: center;
		margin-bottom: 50px;
	}

	.section-header h1 {
		font-size: 36px;
		margin-bottom: 8px;
		font-weight: 700;
	}

	.section-header p {
		font-size: 18px;
		color: #666;
		max-width: 600px;
		margin: 0 auto;
	}

	/* --- Container dos Cards --- */
	.cards-container {
		display: flex;
		justify-content: center;
		align-items: flex-start;
		flex-wrap: wrap;
		gap: 30px;
	}

	/* --- Estilo Base dos Cards --- */
	.card {
		background-color: white;
		border-radius: 12px;
		box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
		padding: 30px;
		width: 280px;
		display: flex;
		flex-direction: column;
		text-align: center;
		transition: all 0.3s ease;
		border: 2px solid transparent;
	}

	.card:hover {
		transform: translateY(-5px);
		box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
	}

	.card h3 {
		font-size: 24px;
		font-weight: 600;
		margin-top: 0;
		margin-bottom: 10px;
	}

	.card .card-description {
		color: #666;
		font-size: 15px;
		min-height: 45px;
		margin-bottom: 20px;
	}

	.card hr {
		border: 0;
		border-top: 1px solid #eee;
		margin: 0;
		margin-bottom: 20px;
	}

	/* --- Lista de Serviços (Features) --- */
	.features-list {
		list-style: none;
		padding: 0;
		text-align: left;
		flex-grow: 1;
		font-size: 15px;
	}

	.features-list li {
		margin-bottom: 12px;
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.feature-included::before {
		content: "✔";
		color: #22c55e;
		font-weight: bold;
	}

	.feature-excluded {
		color: #999;
	}

	.feature-excluded::before {
		content: "✖";
		color: #ef4444;
	}

	/* --- Card em Destaque --- */
	.card-highlighted {
		border: 2px solid var(--dark-blue);
		transform: scale(1.05);
		position: relative;
	}

	.card-highlighted:hover {
		transform: scale(1.05) translateY(-5px);
	}

	.card-highlighted .highlight-text {
		color: var(--dark-blue);
	}

	.badge {
		position: absolute;
		top: -16px;
		left: 50%;
		transform: translateX(-50%);
		background: linear-gradient(45deg, var(--dark-blue), #4a00e0);
		color: white;
		padding: 6px 20px;
		border-radius: 18px;
		font-size: 13px;
		font-weight: bold;
	}

	/* --- Botões --- */
	.button {
		width: 100%;
		padding: 12px;
		border-radius: 8px;
		font-weight: bold;
		cursor: pointer;
		margin-top: 20px;
		transition: all 0.2s ease-in-out;
		border: 2px solid;
	}

	.button-primary {
		background: linear-gradient(45deg, var(--dark-blue), #4a00e0);
		color: white;
		border-color: transparent;
	}
	.button-primary:hover {
		opacity: 0.9;
	}

	.button-secondary {
		background-color: white;
		color: var(--dark-blue);
		border-color: var(--darkest-blue);
	}
	.button-secondary:hover {
		background-color: var(--darkest-blue);
		color: white;
	}

	.button-tertiary {
		background-color: #f0f0f0;
		color: #333;
		border-color: transparent;
		padding-left: 25px;
		padding-right: 25px;
		width: auto;
	}
	.button-tertiary:hover {
		background-color: #ddd;
	}

	@media (min-width: 1950px) {
		.top-content {
			p {
				font-size: 45px;
				width: calc(100vw - 55%);
				strong {
					font-size: 50px;
				}
			}
		}

		.mid-content {
			.content {
				max-width: 100vw;
				display: flex;
				flex-direction: row;
				justify-content: center;
				gap: 40px;
				padding: 30px;
			}
			background-color: var(--darkest-blue);

			p {
				width: 600px;
				color: white;
				font-size: 18px;
			}

			img {
				border-radius: 15px;
				width: 500px;
			}
		}
	}

	@media (max-width: 1500px) {
		.top-content {
			p {
				font-size: 30px;
				width: calc(100vw - 60%);
				strong {
					font-size: 32px;
				}
			}
		}

		.slogan-wrapper {
			img {
				width: calc(100vw - 30%);
			}
		}
	}
	@media (max-width: 1150px) {
		.top-content {
			p {
				font-size: 18px;
				strong {
					font-size: 25px;
				}
			}
		}

		.slogan-wrapper {
			img {
				width: calc(100vw - 20%);
			}
		}
	}
	@media (max-width: 690px) {
		.slogan-wrapper {
			width: 100vw;
			display: flex;
			justify-content: center;
			align-items: center;
			img {
				width: calc(100vw - 5%);
			}
		}
		.top-content {
			display: flex;
			justify-content: center;
			flex-direction: column;
			gap: 15px;
			p {
				font-size: 16px;
				position: static;
				width: calc(100vw - 10%);
				text-shadow: none;
				color: black;
				font-family: "Quicksand", sans-serif;
				font-weight: 500;
				strong {
					font-size: 16px;
					font-family: "Quicksand", sans-serif;
					text-shadow: none;
					font-weight: 500;
					color: var(--main-green);
				}
			}
		}
		#bottom {
			display: flex;
			justify-content: center;
			align-items: center;
			margin: 30px 0;
			padding: 0;
			p {
				max-width: calc(100vw - 10%);
				font-size: 14px;
				text-align: left;
			}
		}

		.mid-content {
			.content {
				width: 100vw;
				flex-direction: column;
				align-items: center;
				img {
					width: calc(100vw - 5%);
				}
				p {
					font-size: 14px;
					width: calc(100vw - 5%);
				}
				un {
					font-size: 14px;
				}
			}
		}
	}
`;
